// extracted by mini-css-extract-plugin
export default {"svg-container":"Graph_svg-container__wwXx8","svg-content-responsive":"Graph_svg-content-responsive__xdLv9","graphBodyStyle":"Graph_graphBodyStyle__yZ9VJ"};